module.exports = __webpack_public_path__ + "static/under-construction-illustration-7c4214840e24cd74cbdb3350f356663f.png";